// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__mXUvm","choiceBoxes":"toolbarselects_choiceBoxes__3GFAi","simpleField":"toolbarselects_simpleField__fM4Dt"};